import React, { useMemo } from 'react';
import classnames from 'classnames';
import { convertHtmlToText } from '@laigu/utils';

import { useMsgWithdraw } from '../work-center/components/context';
import style from './index.less';

const parseRemindStream = stream => {
  const { content_type, content, extra } = stream;
  let text = content;
  switch (content_type) {
    case 'text':
      text = content.replace(/<[a-zA-Z][^>]+>/g, '');
      break;
    case 'rich_text':
      text = convertHtmlToText((extra && extra.content) || content);
      break;
    case 'file':
      text = '[文件]';
      break;
    case 'video':
      text = '[视频]';
      break;
    case 'photo':
      text = '[图片]';
      break;
    default:
      text = content.replace(/<[a-zA-Z][^>]+>/g, '');
  }

  return text;
};

const MessageRemind = props => {
  const { message: activeRemindMessage, handleClickRemindMessage, disabled = false } = props;
  const msgWithdraw = useMsgWithdraw();
  const reviewWithdraw = msgWithdraw && msgWithdraw.reviewWithdraw;

  const isWithdrawn = activeRemindMessage.extra && activeRemindMessage.extra.is_withdrawn && !reviewWithdraw;

  const renderMsg = stream => {
    if (isWithdrawn) {
      return '回复内容已撤回';
    }
    return `${'回复'}：${parseRemindStream(stream)}`;
  };

  const extraProps = useMemo(() => {
    let result = {};
    if (!isWithdrawn) {
      result = {
        ...result,
        onClick: () => handleClickRemindMessage(activeRemindMessage.id)
      };
    }
    return result;
  }, [isWithdrawn, handleClickRemindMessage, activeRemindMessage]);

  if (!activeRemindMessage) {
    return null;
  }
  return (
    <div
      className={classnames(style['remind-message'], { withdrawn: isWithdrawn }, disabled ? style['disabled'] : null)}
      {...extraProps}
    >
      <div className={style.text}>{renderMsg(activeRemindMessage)}</div>
    </div>
  );
};

MessageRemind.parseRemindStream = parseRemindStream;

export default MessageRemind;
